import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Loader2, ShieldCheck } from 'lucide-react';
import { adminLogin, publicSettings } from '../../lib/api';
import { useToast } from '../../hooks/use-toast';
import useSWR from 'swr';

const AdminLogin = () => {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();
  const { data: settings } = useSWR('publicSettings', publicSettings);

  if (localStorage.getItem('ws_admin_token')) {
    return <Navigate to="/admin/orders" replace/>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin(username, password);
      localStorage.setItem('ws_admin_token', res.token);
      toast({ title: 'Welcome back', description: 'Logged in as admin.' });
      navigate('/admin/orders');
    } catch (err) {
      toast({ title: 'Login failed', description: 'Invalid username or password.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] bg-neutral-50 flex items-center justify-center px-4 py-16">
      <form onSubmit={handleSubmit} className="bg-white border border-neutral-200 shadow-sm w-full max-w-md p-8">
        <div className="text-center mb-6">
          {settings?.logo_image ? (
            <img 
              src={settings.logo_image} 
              alt={settings.siteName || "Watch Trader"} 
              style={{ maxWidth: settings.logo_width ? `${settings.logo_width}px` : '150px' }} 
              className="mx-auto mb-4 object-contain max-h-20" 
            />
          ) : (
            <div className="w-14 h-14 mx-auto rounded-full bg-[#b8892d] flex items-center justify-center text-white mb-3">
              <ShieldCheck size={26}/>
            </div>
          )}
          <h1 className="font-serif text-2xl">Admin Panel</h1>
          <p className="text-sm text-neutral-500 mt-1">{settings?.siteName || 'Watch Trader'} management</p>
        </div>
        <div className="space-y-4">
          <div><Label>Username</Label><Input required value={username} onChange={e => setUsername(e.target.value)} className="mt-1"/></div>
          <div><Label>Password</Label><Input required type="password" value={password} onChange={e => setPassword(e.target.value)} className="mt-1" placeholder="admin123"/></div>
          <Button disabled={loading} type="submit" className="w-full bg-[#b8892d] hover:bg-[#a07826] h-11 uppercase tracking-widest text-xs">
            {loading ? <><Loader2 size={16} className="animate-spin mr-2"/> Signing in...</> : 'Sign In'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
